/* eslint-disable max-len */
import { useIntl } from '../../../../hooks/useIntl';
import {
  titleClassName,
  contentContainerClassName,
  dotsContainerClassName,
  reconnectingScreenContainerClassName,
  dotClassName,
  animationDelay,
} from './style.css';

const Wifi = () => (
  <svg
    width={97}
    height={55}
    viewBox="0 0 97 55"
    fill="none"
    opacity={0.3}
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx={48.5} cy={48.5} r={6.5} fill="white" />
    <mask
      id="mask0_61_5776"
      style={{
        maskType: 'alpha',
      }}
      maskUnits="userSpaceOnUse"
      x={6}
      y={0}
      width={85}
      height={49}
    >
      <path
        d="M90.5022 24.25C86.2455 16.8771 80.1229 10.7545 72.75 6.49776C65.3771 2.241 57.0135 -1.92826e-06 48.5 0C39.9865 1.92826e-06 31.6229 2.24101 24.25 6.49777C16.8771 10.7545 10.7545 16.8771 6.49776 24.25L48.5 48.5L90.5022 24.25Z"
        fill="white"
      />
    </mask>
    <g mask="url(#mask0_61_5776)">
      <path
        d="M71 48.5C71 36.0736 60.9264 26 48.5 26C36.0736 26 26 36.0736 26 48.5"
        stroke="white"
        strokeWidth={4}
      />
      <path
        d="M81 48.5C81 30.5507 66.4493 16 48.5 16C30.5507 16 16 30.5507 16 48.5"
        stroke="white"
        strokeWidth={4}
      />
      <path
        d="M91 48.5C91 25.0279 71.9721 6 48.5 6C25.0279 6 6 25.0279 6 48.5"
        stroke="white"
        strokeWidth={4}
      />
    </g>
  </svg>
);

const ReconnectingScreen = () => {
  const { reconnectLabel } = useIntl({
    keys: {
      reconnectLabel: 'game_status.reconnecting',
    },
  });

  return (
    <div className={reconnectingScreenContainerClassName}>
      <div className={contentContainerClassName}>
        <Wifi />
        <div className={dotsContainerClassName}>
          {Array.from({ length: 3 }).map((_, index) => (
            <span
              key={index}
              className={dotClassName}
              style={{ [animationDelay]: `${index * 0.5}s` }}
            />
          ))}
        </div>
        <h1 className={titleClassName}>
          {reconnectLabel}
          ...
        </h1>
      </div>
    </div>
  );
};
export default ReconnectingScreen;
